<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader class="object-header">
            <CRow class="align-items-center">
                <CCol md="5">
                    <h1 class="page__title justify-content">
                        {{ $t(outcome) }}
                    </h1>
                    <!--
                        `total` cuenta envios y `unique_leads` leads distintos:
                        un lead en N salidas suma N. Se ensenan juntos porque en
                        `pending` la diferencia suele ser grande y, sin el
                        segundo numero, el total parece inflado.
                    -->
                    <p class="leads-outcome__counts mb-0">
                        <strong>{{ counts.total }}</strong>
                        <span v-if="counts.unique !== null">
                            ({{ counts.unique }} {{ $t("unique_leads") }})
                        </span>
                    </p>
                </CCol>
                <CCol md="7">
                    <div
                        class="d-flex flex-wrap justify-content-end align-items-center"
                    >
                        <!--
                            `unique=1` devuelve una fila por lead (resumen) y
                            `unique=0` una por envio. Son dos formas de fila
                            distintas, de ahi los dos juegos de columnas.
                        -->
                        <CButtonGroup
                            v-if="!isNotDeliveredAny"
                            class="mr-3"
                        >
                            <CButton
                                :color="unique ? 'secondary' : 'primary'"
                                size="sm"
                                @click="setUnique(false)"
                            >
                                {{ $t("all") }}
                            </CButton>
                            <CButton
                                :color="unique ? 'primary' : 'secondary'"
                                size="sm"
                                @click="setUnique(true)"
                            >
                                {{ $t("unique_only") }}
                            </CButton>
                        </CButtonGroup>
                        <div class="leads-outcome__filter">
                            <FilterDate @updateData="reload" />
                        </div>
                        <ButtonBack />
                    </div>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="p-2 m-0">
                    <CCol md="12">
                        <CCard class="position-relative">
                            <CCardBody>
                                <div
                                    v-if="!table.error && table.rows.length > 0"
                                    class="d-flex justify-content-between align-items-center mb-2"
                                >
                                    <CDropdown
                                        color="primary"
                                        :toggler-text="$t('actions')"
                                        :disabled="selectedLeadIds.length === 0"
                                    >
                                        <CDropdownItem
                                            tag="div"
                                            :disabled="
                                                selectedLeadIds.length === 0
                                            "
                                            @click="openThrottlingSelected()"
                                        >
                                            {{ $t("Throlling delivery") }}
                                            <span class="text-muted">
                                                ({{ selectedLeadIds.length }})
                                            </span>
                                        </CDropdownItem>
                                    </CDropdown>
                                    <CButton
                                        color="primary"
                                        variant="outline"
                                        @click="openThrottlingWholeOutcome()"
                                    >
                                        {{ $t("send_whole_outcome") }}
                                    </CButton>
                                </div>
                                <p
                                    v-if="table.error"
                                    class="leads-outcome__empty mb-0"
                                >
                                    {{ $t("could_not_load_leads_by_outcome") }}
                                    <span v-if="table.error !== true">
                                        ({{ table.error }})
                                    </span>
                                </p>
                                <p
                                    v-else-if="
                                        table.rows.length === 0 &&
                                        !table.loading
                                    "
                                    class="leads-outcome__empty mb-0"
                                >
                                    {{ $t("no_leads_in_this_period") }}
                                </p>
                                <CDataTable
                                    v-else
                                    :addTableClasses="['table--sm']"
                                    :items="table.rows"
                                    :fields="
                                        traslateArrayObjects({
                                            array: fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :hover="true"
                                    :responsive="true"
                                    :clickableRows="isNotDeliveredAny"
                                    @row-clicked="toggleAttempts"
                                    size="sm"
                                >
                                    <template #_attempts="{ item }">
                                        <td class="text-center">
                                            {{ (item.attempts || []).length }}
                                        </td>
                                    </template>
                                    <template #_expand="{ item }">
                                        <td>
                                            <span
                                                class="leads-outcome__caret"
                                                :class="
                                                    hasAttempts(item)
                                                        ? ''
                                                        : 'leads-outcome__caret--empty'
                                                "
                                            >
                                                {{
                                                    isExpanded(item)
                                                        ? "▾"
                                                        : "▸"
                                                }}
                                            </span>
                                        </td>
                                    </template>
                                    <template #details="{ item }">
                                        <CCollapse :show="isExpanded(item)">
                                            <CCardBody>
                                                <p
                                                    v-if="!hasAttempts(item)"
                                                    class="leads-outcome__empty mb-0"
                                                >
                                                    {{ $t("no_attempts") }}
                                                </p>
                                                <table
                                                    v-else
                                                    class="table table-sm mb-0 leads-outcome__attempts"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                {{ $t("output") }}
                                                            </th>
                                                            <th>
                                                                {{ $t("outcome") }}
                                                            </th>
                                                            <th>
                                                                {{ $t("http_status") }}
                                                            </th>
                                                            <th>
                                                                {{ $t("message") }}
                                                            </th>
                                                            <th>
                                                                {{ $t("created_at") }}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            v-for="(
                                                                attempt, index
                                                            ) in item.attempts"
                                                            :key="index"
                                                        >
                                                            <td>
                                                                <RouterLink
                                                                    v-if="
                                                                        attempt.client_uuid
                                                                    "
                                                                    :to="
                                                                        outputRoute(
                                                                            attempt
                                                                        )
                                                                    "
                                                                    >{{
                                                                        attempt.client_name
                                                                    }}</RouterLink
                                                                >
                                                                <span v-else>
                                                                    {{
                                                                        attempt.client_name ||
                                                                        "—"
                                                                    }}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                {{
                                                                    attempt.outcome
                                                                        ? $t(
                                                                              attempt.outcome
                                                                          )
                                                                        : "—"
                                                                }}
                                                            </td>
                                                            <td>
                                                                {{
                                                                    attempt.http_status ===
                                                                        null ||
                                                                    attempt.http_status ===
                                                                        undefined
                                                                        ? "—"
                                                                        : attempt.http_status
                                                                }}
                                                            </td>
                                                            <td>
                                                                {{
                                                                    attempt.message
                                                                }}
                                                            </td>
                                                            <td>
                                                                {{
                                                                    attempt.created_at
                                                                }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </CCardBody>
                                        </CCollapse>
                                    </template>
                                    <template #_selected-header>
                                        <!--
                                            `:checked` de solo lectura:
                                            `allSelected` es un computed sin
                                            setter, y un `.sync` intentaria
                                            asignarle. El cambio se gestiona en
                                            `selectAll`.
                                        -->
                                        <CInputCheckbox
                                            :checked="allSelected"
                                            @update:checked="selectAll"
                                        />
                                    </template>
                                    <template #_selected="{ index }">
                                        <!--
                                            `@click.stop`: la fila se despliega
                                            al clicarla, y marcar el checkbox no
                                            debe desplegarla tambien.
                                        -->
                                        <td @click.stop>
                                            <CInputCheckbox
                                                :checked.sync="
                                                    table.rows[index]._selected
                                                "
                                            />
                                        </td>
                                    </template>
                                    <template #outputs="{ item }">
                                        <td class="text-center">
                                            <span
                                                v-if="outputNames(item)"
                                                v-c-tooltip="outputNames(item)"
                                                class="leads-outcome__outputs"
                                            >
                                                {{ item.outputs }}
                                            </span>
                                            <span v-else>
                                                {{ item.outputs }}
                                            </span>
                                        </td>
                                    </template>
                                    <template #outcomes="{ item }">
                                        <td>
                                            <CBadge
                                                v-for="outcome in item.outcomes ||
                                                []"
                                                :key="outcome"
                                                color="secondary"
                                                class="mr-1"
                                            >
                                                {{ $t(outcome) }}
                                            </CBadge>
                                        </td>
                                    </template>
                                    <template #client_name="{ item }">
                                        <td>
                                            <!--
                                                `not_delivered_any` es a nivel
                                                lead: no hay salida, asi que
                                                client_* llega a null.
                                            -->
                                            <RouterLink
                                                v-if="item.client_uuid"
                                                :to="outputRoute(item)"
                                                >{{ item.client_name }}</RouterLink
                                            >
                                            <span v-else class="text-muted">
                                                —
                                            </span>
                                        </td>
                                    </template>
                                    <template #_reason="{ item }">
                                        <td>
                                            <CBadge
                                                v-if="item.http_status !== null"
                                                color="secondary"
                                                class="mr-2"
                                            >
                                                {{ item.http_status }}
                                            </CBadge>
                                            <span>{{ item.message }}</span>
                                        </td>
                                    </template>
                                    <template
                                        #input_campaign_name="{ item }"
                                    >
                                        <td>
                                            {{ item.input_campaign_name || "—" }}
                                        </td>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter v-if="table.pages > 1">
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="goToPage"
                                        :activePage="table.page"
                                        :pages="table.pages"
                                        align="center"
                                    />
                                </div>
                            </CCardFooter>
                            <CElementCover
                                :opacity="0.8"
                                class="bg-trasparent"
                                v-if="table.loading"
                            />
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
        <CCSendLeadsToDeliveryCampaignWithThrollingDeliveryModal
            :leads="modals.throttling.data.leads || []"
            :initialLeadIds="modals.throttling.data.prefilledIds || ''"
            :show.sync="modals.throttling.show"
            v-on:submit="clearSelection"
        />
    </CCard>
</template>

<script>
/**
 * Components
 */
import ButtonBack from "£lement/ButtonBack";
import FilterDate from "~/components/FilterDate";
import CCSendLeadsToDeliveryCampaignWithThrollingDeliveryModal from "~/components/CCSendLeadsToDeliveryCampaignWithThrollingDeliveryModal";

/**
 * Mixins
 */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";
import modalMixin from "~/mixins/modal.js";

/**
 * Others
 */
import { isBalancerOutcome } from "~/utils/balancerOutcomes";

export default {
    name: "DeliveryCampaignGroupLeadsByOutcomePage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin, modalMixin],
    components: {
        ButtonBack,
        FilterDate,
        CCSendLeadsToDeliveryCampaignWithThrollingDeliveryModal,
    },
    data() {
        return {
            // Este endpoint no usa el envelope `_items`/`total_pages` ni el
            // `query` del resto de la API: lleva `outcome`/`from`/`to`/`page`/
            // `rows` como params sueltos y devuelve `rows`/`pages`. Por eso no
            // pasa por `updateTable`.
            modals: {
                throttling: {
                    show: false,
                    data: {},
                },
            },
            table: {
                loading: false,
                error: null,
                rows: [],
                page: 1,
                pages: 0,
                rowsPerPage: 25,
                total: null,
                uniqueLeads: null,
            },
            unique: false,
            // Leads desplegados, por `lead_id`. Aparte de las filas, para no
            // mutar lo que devuelve el endpoint.
            expanded: {},
        };
    },
    computed: {
        uuid: function () {
            return this.$route.params.uuid;
        },
        outcome: function () {
            return this.$route.params.outcome;
        },
        isNotDeliveredAny: function () {
            return this.outcome === "not_delivered_any";
        },
        /**
         * Las formas de fila del endpoint. En modo unico no hay
         * `client_uuid`, `message` ni `http_status` por fila: es un resumen por
         * lead, con el recuento y los arrays de salidas y resultados.
         */
        fields: function () {
            const selection = {
                key: "_selected",
                label: "",
                sorter: false,
                filter: false,
                _style: "width:3%",
            };
            const lead = { key: "lead_id", label: "lead_id", _style: "width:12%" };
            const input = { key: "input_campaign_name", label: "input" };
            const date = {
                key: "created_at",
                label: "created_at",
                _style: "width:16%",
            };

            // `not_delivered_any` tiene forma propia: una fila por lead con
            // los intentos anidados en `attempts`, cada uno con su salida y su
            // motivo. Van en una fila desplegable.
            if (this.isNotDeliveredAny) {
                return [
                    selection,
                    {
                        key: "_expand",
                        label: "",
                        sorter: false,
                        filter: false,
                        _style: "width:3%",
                    },
                    lead,
                    {
                        key: "_attempts",
                        label: "attempts",
                        _style: "width:8%",
                        _classes: "text-center",
                    },
                    input,
                    date,
                ];
            }

            if (this.unique) {
                return [
                    selection,
                    lead,
                    {
                        key: "occurrences",
                        label: "occurrences",
                        _style: "width:8%",
                        _classes: "text-center",
                    },
                    {
                        // El recuento, con los nombres en el tooltip: una lista
                        // de nombres de salida en la celda desborda la tabla.
                        key: "outputs",
                        label: "outputs",
                        _style: "width:8%",
                        _classes: "text-center",
                    },
                    { key: "outcomes", label: "outcomes" },
                    input,
                    date,
                ];
            }

            return [
                selection,
                lead,
                { key: "client_name", label: "output" },
                { key: "_reason", label: "reason" },
                input,
                date,
            ];
        },
        endpoint: function () {
            return `/shipment.balancing.api/client-groups/${this.uuid}/leads/by-outcome`;
        },
        selectedLeadIds: function () {
            return this.uniqueLeadIds(
                this.table.rows.filter((row) => row._selected)
            );
        },
        allSelected: function () {
            return (
                this.table.rows.length > 0 &&
                this.table.rows.every((row) => row._selected)
            );
        },
        counts: function () {
            const number = (value) => {
                const parsed = parseInt(value, 10);
                return isNaN(parsed) ? null : parsed;
            };
            return {
                total: number(this.table.total) === null ? "-" : number(this.table.total),
                unique: number(this.table.uniqueLeads),
            };
        },
    },
    watch: {
        // `openModal` del mixin FUSIONA los datos, asi que si no se limpian al
        // cerrar, la siguiente apertura podria arrastrar los ids de la
        // anterior y enviar mas leads de los marcados.
        "modals.throttling.show"(value) {
            if (!value) {
                this.modals.throttling.data = {};
            }
        },
    },
    methods: {
        /**
         * Ids de los leads marcados, sin repetir.
         *
         * Importante: esta lista cuenta ENVIOS, asi que un mismo lead puede
         * aparecer en varias filas (en `pending`, `total` suele ser bastante
         * mayor que `unique_leads`). Sin deduplicar, el reenvio mandaria el
         * mismo lead varias veces.
         */
        uniqueLeadIds(rows) {
            const seen = [];
            rows.forEach((row) => {
                const id = parseInt(row.lead_id, 10);
                if (!isNaN(id) && seen.indexOf(id) === -1) {
                    seen.push(id);
                }
            });
            return seen;
        },
        /**
         * Se le pasan las dos cosas: los ids en `prefilledIds`, que es lo que
         * el modal usa por defecto, y los leads en `leads`. Sin `leads` el
         * modal deja "usar seleccionados" deshabilitado, asi que al pulsar
         * "introducir leads manualmente" la seleccion se perdia y quedaba un
         * textarea vacio.
         */
        openThrottlingSelected() {
            this.openModal({
                modalName: "throttling",
                data: {
                    leads: this.selectedLeadIds.map((id) => ({ id })),
                    prefilledIds: this.selectedLeadIds.join(","),
                },
            });
        },
        /**
         * Todo el outcome del periodo, no solo la pagina visible: recorre las
         * paginas que declara el endpoint y deduplica.
         */
        async openThrottlingWholeOutcome() {
            this.updatePageLoading(true);
            try {
                const rows = await this.fetchAllPages();
                const ids = this.uniqueLeadIds(rows);
                this.openModal({
                    modalName: "throttling",
                    data: {
                        leads: ids.map((id) => ({ id })),
                        prefilledIds: ids.join(","),
                    },
                });
            } catch (error) {
                this.showMessageError(error);
            } finally {
                this.updatePageLoading(false);
            }
        },
        /**
         * Recorre el periodo completo SIEMPRE en modo unico: el conjunto de
         * leads es el mismo que en modo normal (una fila por lead en vez de una
         * por envio), asi que son menos paginas y menos peticiones para la
         * misma lista de ids.
         */
        async fetchAllPages() {
            let rows = [];
            let page = 1;
            let pages = 1;
            do {
                const response = await this.fetcher({
                    url: this.endpoint,
                    query: {
                        outcome: this.outcome,
                        unique: 1,
                        from: this.storeFrom,
                        to: this.storeTo,
                        page,
                        rows: this.table.rowsPerPage,
                    },
                });
                rows = rows.concat(response.rows || []);
                pages = parseInt(response.pages, 10) || 1;
                page += 1;
            } while (page <= pages);
            return rows;
        },
        selectAll(checked) {
            this.table.rows.forEach((row) => {
                this.$set(row, "_selected", checked);
            });
        },
        clearSelection() {
            this.selectAll(false);
        },
        /**
         * Nombres de las salidas de ese lead, para el tooltip del recuento.
         */
        outputNames(row) {
            const names = row.client_names || [];
            return names.length > 0 ? names.join(", ") : "";
        },
        hasAttempts(row) {
            return Array.isArray(row.attempts) && row.attempts.length > 0;
        },
        isExpanded(row) {
            return Boolean(this.expanded[row.lead_id]);
        },
        toggleAttempts(row) {
            this.$set(this.expanded, row.lead_id, !this.expanded[row.lead_id]);
        },
        outputRoute(row) {
            return {
                name: "update_delivery_campaign",
                params: { uuid: row.client_uuid },
                query: { view_type: "edit" },
            };
        },
        goToPage(page) {
            if (page === this.table.page) {
                return;
            }
            this.table.page = page;
            this.load();
        },
        /**
         * Cambiar de modo cambia el numero de filas y de paginas, asi que se
         * vuelve a la primera.
         */
        setUnique(value) {
            if (this.unique === value) {
                return;
            }
            this.unique = value;
            this.reload();
        },
        /**
         * Al cambiar la ventana de fechas se vuelve a la primera pagina: la
         * paginacion del rango anterior no tiene por que existir en el nuevo.
         */
        reload() {
            this.table.page = 1;
            this.load();
        },
        async load() {
            if (!isBalancerOutcome(this.outcome)) {
                this.table.rows = [];
                this.table.error = `outcome: ${this.outcome}`;
                return;
            }

            this.table.loading = true;
            this.table.error = null;
            try {
                const response = await this.fetcher({
                    url: this.endpoint,
                    query: {
                        outcome: this.outcome,
                        unique: this.unique ? 1 : 0,
                        from: this.storeFrom,
                        to: this.storeTo,
                        page: this.table.page,
                        rows: this.table.rowsPerPage,
                    },
                });
                // `_selected` explicito: al cambiar de pagina o de rango las
                // filas son otras y no debe arrastrarse la seleccion.
                this.expanded = {};
                this.table.rows = (response.rows || []).map((row) => ({
                    ...row,
                    _selected: false,
                }));
                this.table.pages = parseInt(response.pages, 10) || 0;
                this.table.total = response.total;
                this.table.uniqueLeads = response.unique_leads;
            } catch (error) {
                this.table.rows = [];
                this.table.pages = 0;
                this.table.total = null;
                this.table.uniqueLeads = null;
                this.table.error =
                    (error && error.response && error.response.status) ||
                    (error && error.message) ||
                    true;
            }
            this.table.loading = false;
        },
    },
    async mounted() {
        await this.load();
        this.$store.dispatch("page/updateLoading", { loading: false });
    },
};
</script>

<style scoped lang="scss">
.leads-outcome {
    &__counts {
        font-size: 0.9rem;
        color: #768192;
    }

    &__caret {
        color: #768192;
        font-size: 0.7rem;

        &--empty {
            opacity: 0.35;
        }
    }

    &__attempts {
        font-size: 0.8rem;
    }

    &__outputs {
        cursor: help;
        border-bottom: 1px dotted #768192;
    }

    &__empty {
        font-size: 0.8rem;
        color: #768192;
    }
}
</style>
